import * as React from 'react';
import { resolve } from 'inversify-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { BrandListDataService } from 'src/app/general/brands/list/brand-list.data';
import { BrandEditorCheckListView } from './brand-editor-checkList.view';

interface BrandEditorCheckListControllerProps {
	value: number | null;
	mode: ControlMode;
	onChanged: (value: number | null) => void;
	setBusy(isBusy: boolean);
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

export class BrandEditorCheckListController extends React.Component<BrandEditorCheckListControllerProps, {}> {
	private brandDataService: BrandListDataService;

	@resolve
	private toast: ToastNotifications;

	public componentDidMount() {
		this.load();
	}

	public render() {
		if (this.brandDataService == null) {
			return null;
		}
		return (
			<BrandEditorCheckListView
				brands={this.brandDataService.items}
				onGetErrorMessage={this.props.onGetErrorMessage}
				{...this.props}
			/>
		);
	}

	private load() {
		try {
			this.props.setBusy(true);
			this.brandDataService = BrandListDataService.make();
			this.brandDataService.addFilter('isDeleted', 'eq', false);
			this.brandDataService.addSorting('id', 'asc', true);
			this.brandDataService.load(query => query);
		} catch (error) {
			this.toast.showToast("Error in request!", ObjectUtils.parseError(error), "error");
		} finally {
			this.props.setBusy(false);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/general/brands/parts/brand-editor-checkList.controller.tsx